(function () {
  if (!window.theme || window.theme.cartType !== 'drawer') {
    return;
  }

  function isCartPageUrl(url) {
    if (!url) {
      return false;
    }

    var value = String(url);

    try {
      var parsed = new URL(value, window.location.origin);
      var path = parsed.pathname.replace(/\/+$/, '') || '/';
      return path === '/cart' || path.endsWith('/cart');
    } catch (error) {
      return /\/cart\/?($|\?|#)/.test(value);
    }
  }

  function openWarehouseCartDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        scrollToTop: false,
        skipLoadingStart: true
      }
    }));

    var miniCart = document.getElementById('mini-cart');

    if (miniCart && miniCart.getAttribute('aria-hidden') !== 'false') {
      var toggle = document.querySelector('[data-action="toggle-mini-cart"]');

      if (toggle) {
        toggle.click();
      }
    }
  }

  window.__warehouseOpenCartDrawer = openWarehouseCartDrawer;

  // Fast Bundle already supports Monster Cart's drawer hooks. Register ours the
  // same way so FBT uses openCartDrawer + syncCartDrawer instead of /cart redirect.
  window.monster_refresh = function () {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        scrollToTop: false,
        skipLoadingStart: true
      }
    }));
  };

  window.openCart = openWarehouseCartDrawer;

  function patchFastBundleCartAction(config) {
    if (!config || !config.bundleBox) {
      return false;
    }

    config.bundleBox.cart_drawer_function = 'window.__warehouseOpenCartDrawer()';
    config.bundleBox.redirect_to_cart = false;
    return true;
  }

  function interceptCartNavigation() {
    if (window.__warehouseCartNavigationIntercepted) {
      return;
    }

    window.__warehouseCartNavigationIntercepted = true;

    var originalOpen = window.open;

    window.open = function (url, target) {
      if (isCartPageUrl(url)) {
        openWarehouseCartDrawer();
        return null;
      }

      return originalOpen.apply(window, arguments);
    };

    if (window.navigation && window.navigation.addEventListener) {
      window.navigation.addEventListener('navigate', function (event) {
        if (!isCartPageUrl(event.destination && event.destination.url)) {
          return;
        }

        if (!event.canIntercept) {
          return;
        }

        event.intercept({
          handler: function () {
            openWarehouseCartDrawer();
          }
        });
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');

      if (!link || link.getAttribute('data-action') === 'toggle-mini-cart') {
        return;
      }

      if (!isCartPageUrl(link.href)) {
        return;
      }

      if (!link.closest('[id*="rbr"], [class*="rbr"], [id*="fast-bundle"], [class*="fast-bundle"]')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openWarehouseCartDrawer();
    }, true);
  }

  interceptCartNavigation();

  if (!patchFastBundleCartAction(window.FastBundleConf)) {
    var currentConfig = window.FastBundleConf;

    try {
      Object.defineProperty(window, 'FastBundleConf', {
        configurable: true,
        enumerable: true,
        get: function () {
          return currentConfig;
        },
        set: function (value) {
          currentConfig = value;
          patchFastBundleCartAction(value);
        }
      });
    } catch (error) {
      // FastBundleConf may already exist as a non-configurable property.
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchFastBundleCartAction(window.FastBundleConf);
  });
})();
